var TRANSITION_DURATION = 250;
window.TRANSITION_DURATION = 250;
